<script setup>
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import axios from "axios";
//----------------------------------------------------------------------
const store = useStore()
const docs1 = ref([])
const docs2 = ref([])
onMounted( ()=>{
  init()
})

const init = async () => {
  store.commit('menuModule/initMenu')
  let urlDocs1 = process.env.VUE_APP_API + 'real-estate-docs-1.php'
  let urlDocs2 = process.env.VUE_APP_API + 'real-estate-docs-2.php'
  await axios
      .get(`${urlDocs1}?token=${token.value}`)
      .then(response => (docs1.value = response.data))
      .then(
          await axios
              .get(`${urlDocs2}?token=${token.value}`)
              .then(response => (docs2.value = response.data))
      )
      .catch(error => alert(error));

}
//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
</script>

<template>
  <main class="content-wrapper">

  <section class="content-header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h3>Нормативные документы</h3>
        </div>
      </div>
    </div>
  </section>

  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header header-bg">
              <h5 class="mt-1">1. Нормативные документы для первичного рынка</h5>
            </div>
            <div class="card-body">
              <div v-for="(doc,index) in docs1" :key="index"
                   class="doc-download"
              >
                <a :href="'https://lk.gorcenter.spb.ru/documents/' + doc.link" class="black-link">
                  <h6>{{ doc.name }}</h6>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12">
          <div class="card">
            <div class="card-header header-bg">
              <h5 class="mt-1">2. Нормативные документы для вторичного рынка</h5>
            </div>
            <div class="card-body">
              <div v-for="(doc,index) in docs2" :key="index"
                   class="doc-download"
              >
                <a
                    :href="'https://lk.gorcenter.spb.ru/documents/' + doc.link" class="black-link"
                    :target="doc.target"
                >
                  <h6>{{ doc.name }}</h6>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <br>

    </div>
  </section>
  </main>
</template>

<style scoped>
.doc-download{
  background-image:url(//lk.gorcenter.spb.ru/images/doc.svg);
  background-repeat:no-repeat;
  background-position: 0% 50%;
  background-size: 50px;
  padding:27px 0 20px 70px;
}
.header-bg{
  background-color: #80b5d3;
  color: #fff;
}
</style>